import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import useMediaQuery from '@mui/material/useMediaQuery'
import { Outlet } from 'react-router-dom'

import { Header } from '@components/header'
import { ProfileNavMenu } from '@components/profile_nav/profile_nav'
import { useSessionContext } from '@providers/session'
import { useLocationSetup } from 'hooks/use_location_setup'
import { useMonitoringData } from 'hooks/use_monitoring_data'

export const ProfileLayout = () => {
  const theme = useTheme()
  const { state } = useSessionContext()

  useLocationSetup()
  useMonitoringData()

  const isBelowMD = useMediaQuery(theme.breakpoints.down('md'))

  // Logout clears the user before AppLayout's redirect runs. Unmount profile
  // consumers and their navigation blockers during that transition.
  if (!state.user?.token || !state.user.lupId) return null

  return (
    <>
      <Header />
      <Box width="100%" sx={{ maxWidth: { lg: 1250 } }} margin="40px auto">
        <Stack direction="row" spacing={isBelowMD ? 0 : 3}>
          {!isBelowMD && <ProfileNavMenu />}
          <Box flex={1} minWidth={0}>
            <Outlet />
          </Box>
        </Stack>
      </Box>
    </>
  )
}
